import { Content } from '@phrasee/phrasee-typings'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'

import { duplicateElement } from '../api'
import { contentKeys } from '../queryKeys'

const useDuplicateElementMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(duplicateElement, {
    onError: () => {
      errorToast('Failed to duplicate element. Please try again.')
    },
    onSuccess: (content: Content) => {
      const contentId = content._id

      queryClient.setQueryData(contentKeys.content(contentId), content)
      successToast('Element duplicated successfully.')
    },
  })
}

export default useDuplicateElementMutation
